import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { UserListDialog } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { open } = state.userListDialog
  var users = ownProps.users
  users.sort((a, b) => {
    return a.displayName < b.displayName
  })

  return ({
    open,
    users
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClose: () => {
      dispatch(actions.usereListDialog.close())
    }      
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserListDialog)



// WEBPACK FOOTER //
// ./src/containers/Common/Chat/UserListDialog.js